import { captureException } from "@sentry/nextjs";

import type { TvlResponse } from "types/tvl-response";

export async function fetchTvlInfo(): Promise<TvlResponse | undefined> {
  try {
    const response = await fetch("https://api.marinade.finance/tlv");

    if (!response.ok) {
      throw new Error(`${response.statusText} /// ${response.status}`);
    }

    return await response.json();
  } catch (err) {
    captureException(err);
    return undefined;
  }
}
